import type { JobFilters } from '@/components/job-feed/FilterRail';
import type { Job } from '@/types/job.type';

export const SORT_OPTIONS = [
  { id: 'score', label: 'Score (high)' },
  { id: 'recent', label: 'Most recent' },
  { id: 'salary', label: 'Salary (high)' },
  { id: 'company', label: 'Company A-Z' },
] as const;

export type SortId = (typeof SORT_OPTIONS)[number]['id'];

export interface JobRowProps {
  job: Job;
}

export type { JobFilters };
